// extracted by mini-css-extract-plugin
export default {"container":"ContainerFluid_container__p-hBT"};